(function () {
  if (window.__asmCartQuantitySyncReady) return;
  window.__asmCartQuantitySyncReady = true;

  var lastCart = { items: [] };
  var timers = [];
  var mutationEpoch = 0, syncSequence = 0;

  function rootPath() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function quantityMap(cart) {
    var map = {};
    (cart.items || []).forEach(function (item) {
      var id = String(item.variant_id || item.id || '');
      if (id) map[id] = (map[id] || 0) + Number(item.quantity || 0);
    });
    return map;
  }

  function updatePanel(panel, map) {
    var select = panel.querySelector('select[name="id"],select.product-variant-id,select');
    var idInput = panel.querySelector('form[action*="/cart/add"] [name="id"]');
    var variantId = select ? String(select.value) : (idInput ? String(idInput.value) : '');

    if (select && !map[variantId]) {
      Array.prototype.some.call(select.options, function (option) {
        if (map[String(option.value)]) {
          variantId = String(option.value);
          select.value = variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
        return false;
      });
    }

    var amount = map[variantId] || 1;
    var visible = panel.querySelector('.asm-card-qty input,.asm-qty input,.asm-card-qty span,.asm-qty span');
    var formQuantity = panel.querySelector('form[action*="/cart/add"] [name="quantity"]');

    if (visible) {
      if ('value' in visible) visible.value = String(amount);
      else visible.textContent = String(amount);

      if (visible.dataset && visible.dataset.asmQuantityKey) {
        try {
          if (map[variantId]) sessionStorage.setItem(visible.dataset.asmQuantityKey, String(amount));
          else sessionStorage.removeItem(visible.dataset.asmQuantityKey);
        } catch (error) {}
      }
    }

    if (formQuantity && formQuantity !== visible) formQuantity.value = String(amount);

    var minus = panel.querySelector('.asm-card-qty button:first-child,.asm-qty button:first-child');
    if (minus) {
      minus.disabled = amount <= 1;
      minus.setAttribute('aria-disabled', amount <= 1 ? 'true' : 'false');
    }
  }

  function apply(cart, scope) {
    lastCart = cart || { items: [] };
    var memory = window.asmSelectionMemory;
    if (memory && memory.isEnabled()) {
      memory.seedCart(lastCart);
      memory.refresh(scope || document);
      document.dispatchEvent(new CustomEvent('asm:cart-quantities-synced', { detail: lastCart }));
      return;
    }
    var map = quantityMap(lastCart);
    (scope || document).querySelectorAll('.asm-product,.asm-card-purchase').forEach(function (panel) {
      updatePanel(panel, map);
    });
    document.dispatchEvent(new CustomEvent('asm:cart-quantities-synced', { detail: lastCart }));
  }

  function sync() {
    var epoch = mutationEpoch, sequence = ++syncSequence;
    return fetch(rootPath() + 'cart.js?asm_quantity_sync=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('cart-sync');
      return response.json();
    }).then(function (cart) {
      // A late response from before a newer cart edit must not reset a sent order.
      if (epoch !== mutationEpoch || sequence !== syncSequence) return null;
      document.dispatchEvent(new CustomEvent('asm:cart-confirmed', { detail: cart }));
      apply(cart);
      return cart;
    }).catch(function () {
      return null;
    });
  }

  function scheduleSync() {
    timers.forEach(window.clearTimeout);
    timers = [
      window.setTimeout(sync, 120),
      window.setTimeout(sync, 480),
      window.setTimeout(sync, 1000)
    ];
  }

  var previousFetch = window.fetch.bind(window);
  window.fetch = function () {
    var args = arguments;
    var requestUrl = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var mutation = requestUrl.match(/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/);
    var epoch = mutation ? ++mutationEpoch : mutationEpoch;
    return previousFetch.apply(window, args).then(function (response) {
      if (mutation) {
        scheduleSync();
        if (response.ok) response.clone().json().then(function (result) {
          if (epoch !== mutationEpoch) return;
          if (mutation[1] === 'add') {
            var added = Array.isArray(result.items) ? result.items : [result];
            if (added.some(function (item) { return (item.variant_id || item.id) && Number(item.quantity) > 0; })) document.dispatchEvent(new CustomEvent('asm:cart-product-added'));
          } else if (Array.isArray(result.items)) {
            document.dispatchEvent(new CustomEvent('asm:cart-confirmed', { detail: result }));
          }
        }).catch(function () { /* The scheduled authoritative cart read remains available. */ });
      }
      return response;
    });
  };

  document.addEventListener('change', function (event) {
    if (window.asmSelectionMemory && window.asmSelectionMemory.isEnabled()) return;
    if (event.target.matches('.asm-card-purchase select[name="id"],.asm-product select')) {
      var panel = event.target.closest('.asm-product,.asm-card-purchase');
      if (panel) updatePanel(panel, quantityMap(lastCart));
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('cart-remove-button,.cart-remove-button,[data-asm-clear-cart],button[name="update"],quantity-input button')) {
      scheduleSync();
    }
  }, true);

  document.addEventListener('cart:refresh', scheduleSync);
  document.addEventListener('shopify:section:load', function (event) {
    apply(lastCart, event.target || document);
    scheduleSync();
  });
  window.addEventListener('pageshow', sync);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sync();
  });

  var observer = new MutationObserver(function (mutations) {
    var hasNewCards = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
        return node.nodeType === 1 && (node.matches('.asm-product,.asm-card-purchase') || node.querySelector('.asm-product,.asm-card-purchase'));
      });
    });
    if (hasNewCards) apply(lastCart);
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.asmSyncCartCardQuantities = sync;
})();
